import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength, integer, email as emailVal } from 'vuelidate/lib/validators';


@Component({})
class EdVerifyCodeInputComponent extends Vue {

  /* Data */
  public form: any = {};
  public numberOfFields: number = 6;

  /* Methods */
  private init() {
    this.form = EdFormModel([
      EdInputModel('field1', '', {}, true),
      EdInputModel('field2', '', {}, true),
      EdInputModel('field3', '', {}, true),
      EdInputModel('field4', '', {}, true),
      EdInputModel('field5', '', {}, true),
      EdInputModel('field6', '', {}, true),
    ]);
  }

  focusNext(event, id) {
    let elId = Number(id);
    let nextElId;
    var key = event.keyCode || event.charCode;
    if(key == 8) nextElId = elId - 1;
    else nextElId = elId + 1;
    if(((nextElId < elId && elId != 1) || (nextElId > elId && elId != this.numberOfFields)) && key !== 9)
      document.getElementById(nextElId.toString()).getElementsByTagName('input')[0].focus()
  }

  sendCode() {
    let code = '';
    for (let i = 1; i <= this.numberOfFields; i++) {
      code = code + this.form[`field${i}`].value
    }
    this.$emit('getCode', code)
  }

  validateField(index) {
    let regex = /^[0-9]*$/
    if (this.form[`field${index}`].value.length > 1){
      this.form.set(`field${index}`, this.form[`field${index}`].value.charAt(this.form[`field${index}`].value.length - 1));
    }
    if(!regex.test(this.form[`field${index}`].value)) {
      this.form.set(`field${index}`, '')
    }
  }

  /* Hooks */
  created() {
    this.init();
  }

  mounted() {
    document.querySelector<HTMLElement>('.ed-verify-code-input__form')
      .style.setProperty('grid-template-columns', `repeat(${this.numberOfFields + 1}, 1fr)`);
  }

}

export default Vue.component('ed-verify-code-input', EdVerifyCodeInputComponent);